import { Link } from 'react-router-dom'
import { useRecordProcess } from '@/hooks/useProcess'
import type { TaskRead } from '@/types/process'
import { taskStatusLine } from './taskStatusText'

/** SA-1032 (spec D5): a task that is no longer live says what ended it and
 * where the process is now, with the record one click away. The record read
 * is the band's own; while it loads, or after it failed with nothing cached,
 * `data` is undefined and only the first sentence shows (the strip's rule). */
export function TaskStatusBlock({ task }: { task: TaskRead }) {
  // Read afresh on mount: "now at …" must not trail the task's own fresh read.
  const record = useRecordProcess(task.order_id, { staleTime: 0 })
  return (
    <div className="space-y-1">
      {/* SA-1418 (C3): no live region. The line is the page's content, read in place; as a live
          region it was announced twice, once per sentence as the record read landed. */}
      <p data-testid="task-status-line" className="text-sm">{taskStatusLine(task, record.data)}</p>
      <Link to={`/orders?order=${task.order_id}`} className="text-xs underline">Open the record</Link>
    </div>
  )
}
